const rankings = [
  { rank: 1, title: '庆余年3', heat: '热度 9.8', trend: 'up', tag: '国产剧' },
  { rank: 2, title: '背着善宰跑', heat: '热度 9.2', trend: 'up', tag: '韩剧' },
  { rank: 3, title: '墨雨云间', heat: '热度 8.7', trend: 'up', tag: '国产剧' },
  { rank: 4, title: '泪之女王', heat: '热度 8.4', trend: 'down', tag: '韩剧' },
  { rank: 5, title: '繁花', heat: '热度 7.9', trend: 'same', tag: '国产剧' },
  { rank: 6, title: '玫瑰的故事', heat: '热度 7.3', trend: 'up', tag: '国产剧' },
  { rank: 7, title: '长相思2', heat: '热度 6.8', trend: 'up', tag: '国产剧' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-3">
              实时热度
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              热播榜单
            </h2>
            <p className="text-sm text-foreground-500 mt-2">本周最受追剧用户欢迎的剧集</p>
          </div>

          <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankings.map((item, i) => (
              <a
                key={i}
                href="#ranking"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/50 transition-colors cursor-pointer ${
                  i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-primary-500 text-background-50'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900 font-heading whitespace-nowrap">
                      {item.title}
                    </span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-background-200 text-foreground-500 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>

                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>

                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                  {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}